"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsLogin = void 0;
exports.loginUser = loginUser;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
require("regenerator-runtime/runtime");
var _server = require("../../service/server/server.js");
var _HttpStatus = require("../../constants/HttpStatus.js");
var _reactRouterDom = require("react-router-dom");
var _NamedRoutes = require("../../constants/NamedRoutes.js");
var _LocalStorage = require("../../constants/LocalStorage.js");
var _DmsFetch = require("../../components/DmsFetch/DmsFetch.js");
var _index = require("../../index.js");
var _DmsKeyboardButton = require("../../components/DmsKeyboardButton/DmsKeyboardButton.js");
var _DmsAlertPutFinger = _interopRequireDefault(require("../../components/DmsAlertPutFinger/DmsAlertPutFinger.js"));
var _material = require("@mui/material");
var _Images = require("../../constants/Images.js");
var _Lock = _interopRequireDefault(require("@mui/icons-material/Lock"));
var _Email = _interopRequireDefault(require("@mui/icons-material/Email"));
var _Fingerprint = _interopRequireDefault(require("@mui/icons-material/Fingerprint"));
var _Speed = _interopRequireDefault(require("@mui/icons-material/Speed"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/**
 * Logs in a user by sending credentials to the authentication server.
 * @async
 * @param {Object} props - The properties for the login request.
 * @param {string} props.authentication_url - The URL of the authentication server.
 * @param {string} props.login - The user's login name.
 * @param {string} props.password - The user's password.
 * @returns {Promise<Object>} The response from the authentication server.
 */
async function loginUser(_ref) {
  let {
    authentication_url,
    login,
    password
  } = _ref;
  if (authentication_url === undefined) return "fake-token";
  authentication_url = (0, _server.getURL)(authentication_url);
  const credentials = {
    grant_type: "password",
    username: login,
    password: password
  };
  const body = new URLSearchParams(credentials).toString();
  return fetch(authentication_url, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/x-www-form-urlencoded"
    },
    body: body
  }).then(response => response.json().then(data => {
    let params = "";
    if (data.params) {
      params = data.params;
    }
    return {
      data: data,
      status: response.status,
      params: params
    };
  }));
}

/**
 * A login component for handling user authentication.
 * @param {Object} props - The properties for the login component.
 * @param {string} props.authentication_url - The URL of the authentication server.
 * @param {Function} props.setToken - Function to set the authentication token.
 * @param {boolean} [props.virtualKeyboard=false] - Whether to show the virtual keyboard.
 * @param {boolean} [props.showAutomaticButton=false] - Whether to show the automatic button
 * @param {React.ElementType} [props.automaticIcon] - Custom icon for the automatic button
 * @returns {JSX.Element} The login component.
 */
const DmsLogin = _ref2 => {
  let {
    authentication_url,
    setToken,
    virtualKeyboard = false,
    showAutomaticButton = false,
    automaticIcon = false
  } = _ref2;
  const [login, setLogin] = (0, _react.useState)(null);
  const [password, setPassword] = (0, _react.useState)();
  const [showModalFingerPrinter, setShowModalFingerPrinter] = (0, _react.useState)(false);
  const [fingerPrinterEnabled, setFingerPrinterEnabled] = (0, _react.useState)(false);
  const AutomaticIcon = automaticIcon || _Speed.default;
  const url_params = new URLSearchParams(window.location.search);
  const error_message = url_params.get("message");
  const navigate = (0, _reactRouterDom.useNavigate)();
  const [canAccessAutomatic, setCanAccessAutomatic] = (0, _react.useState)(showAutomaticButton);
  (0, _react.useEffect)(() => {
    if (!showAutomaticButton) return;
    const checkAutomaticRoute = async () => {
      try {
        const response = await fetch('/automatic', {
          method: 'HEAD',
          signal: AbortSignal.timeout(1000)
        });
        if (response.ok) {
          setCanAccessAutomatic(true);
        }
      } catch (error) {
        console.log("Automatic route not available");
      }
    };
    checkAutomaticRoute();
  }, [showAutomaticButton]);
  (0, _react.useEffect)(() => {
    const fetchFingerPrinterConfig = async () => {
      var _response$data;
      const response = await (0, _DmsFetch.fetchData)((0, _server.getURL)("/login_settings/finger_printer_login"), "GET", false);
      if (((_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.data) !== undefined) {
        setFingerPrinterEnabled(response.data.data);
      }
    };
    fetchFingerPrinterConfig();
  }, []);
  const successLogin = async user_auth => {
    setToken(user_auth.data);
    setShowModalFingerPrinter(false);
    sessionStorage.setItem("expirationSwalShow", "true");
    sessionStorage.setItem("fingerPrinterEnabled", fingerPrinterEnabled);
    localStorage.setItem(_LocalStorage.LocalStorageVariables.InactivityTimer, user_auth.data.inactivity_timer);
    navigate(_NamedRoutes.ROUTES.Home, {
      replace: true
    });
  };
  const failLogin = async user_auth => {
    localStorage.clear();
    sessionStorage.clear();
    setShowModalFingerPrinter(false);
    navigate("".concat(_NamedRoutes.ROUTES.Login, "?message=").concat(user_auth.data.detail));
  };
  const handleSubmit = async e => {
    e.preventDefault();
    const user_auth = await loginUser({
      login,
      password,
      authentication_url
    });
    if (user_auth.status === _HttpStatus.HTTP_STATUS.OK_200) {
      setToken(user_auth.data);
      sessionStorage.setItem("expirationSwalShow", "true");
      localStorage.setItem(_LocalStorage.LocalStorageVariables.InactivityTimer, user_auth.data.inactivity_timer);
      navigate(_NamedRoutes.ROUTES.Home, {
        replace: true
      });
      successLogin(user_auth);
    } else {
      failLogin(user_auth);
    }
  };
  const handleSubmitFingerPrinter = async e => {
    setShowModalFingerPrinter(true);
    const user_id = await (0, _DmsFetch.fetchData)((0, _server.getURL)("/finger_printer/device/get_user_template"), "GET", false);
    if (user_id.status === _HttpStatus.HTTP_STATUS.OK_200) {
      console.log(user_id);
      const user_auth = await (0, _DmsFetch.fetchData)((0, _server.getURL)("/finger_printer/token"), "POST", false, user_id.data.data);
      if (user_auth.status === _HttpStatus.HTTP_STATUS.OK_200) {
        successLogin(user_auth);
      } else {
        failLogin(user_auth);
      }
    } else {
      failLogin(user_id);
    }
  };
  const handleGoToAutomatic = () => {
    navigate('/automatic');
  };
  return /*#__PURE__*/_react.default.createElement(_material.Container, {
    className: "login-page",
    maxWidth: "false",
    sx: {
      background: "url(".concat(_Images.IMAGES.BACKGROUND, ") no-repeat center center fixed"),
      backgroundSize: "cover"
    }
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "100vh"
  }, /*#__PURE__*/_react.default.createElement(_material.Card, {
    sx: {
      maxWidth: "20rem",
      width: "20rem"
    }
  }, /*#__PURE__*/_react.default.createElement(_material.CardContent, null, /*#__PURE__*/_react.default.createElement(_material.Box, {
    display: "flex",
    justifyContent: "center",
    mb: 3
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: _Images.IMAGES.LOGO,
    alt: "Logo"
  })), error_message ? /*#__PURE__*/_react.default.createElement(_material.Alert, {
    severity: "error",
    sx: {
      marginBottom: "2vh",
      wordBreak: "break-word"
    }
  }, error_message) : /*#__PURE__*/_react.default.createElement(_material.Alert, {
    severity: "info",
    color: "warning",
    sx: {
      marginBottom: "2vh"
    }
  }, _index.intl.get("Signintostintlsession").d("Sign in to start your session")), /*#__PURE__*/_react.default.createElement("form", {
    onSubmit: handleSubmit
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    mb: 3
  }, /*#__PURE__*/_react.default.createElement(_material.TextField, {
    required: true,
    autoComplete: "username",
    id: "username",
    label: _index.intl.get("EnterLogin").d("Enter Login"),
    fullWidth: true,
    variant: "outlined",
    onChange: e => setLogin(e.target.value),
    InputProps: {
      endAdornment: /*#__PURE__*/_react.default.createElement(_material.InputAdornment, {
        position: "end"
      }, /*#__PURE__*/_react.default.createElement(_Email.default, null))
    }
  })), /*#__PURE__*/_react.default.createElement(_material.Box, {
    mb: 3
  }, /*#__PURE__*/_react.default.createElement(_material.TextField, {
    required: true,
    autoComplete: "current-password",
    id: "password",
    label: _index.intl.get("Password").d("Password"),
    type: "password",
    fullWidth: true,
    variant: "outlined",
    onChange: e => setPassword(e.target.value),
    InputProps: {
      endAdornment: /*#__PURE__*/_react.default.createElement(_material.InputAdornment, {
        position: "end"
      }, /*#__PURE__*/_react.default.createElement(_Lock.default, null))
    }
  })), /*#__PURE__*/_react.default.createElement(_material.Button, {
    type: "submit",
    variant: "contained",
    color: "primary",
    fullWidth: true
  }, _index.intl.get("Login").d("Login"))), /*#__PURE__*/_react.default.createElement(_material.Box, {
    mt: 3
  }, /*#__PURE__*/_react.default.createElement(_material.Divider, null), /*#__PURE__*/_react.default.createElement(_index.DmsFlexContainer, null, /*#__PURE__*/_react.default.createElement(_index.DmsFlexContainer.Left, null, canAccessAutomatic && /*#__PURE__*/_react.default.createElement(_material.IconButton, {
    onClick: handleGoToAutomatic,
    color: "primary",
    "aria-label": _index.intl.get("AutomaticDashboard").d("Automatic Dashboard"),
    sx: {
      ':hover': {
        backgroundColor: 'primary.light'
      }
    }
  }, /*#__PURE__*/_react.default.createElement(AutomaticIcon, null))), /*#__PURE__*/_react.default.createElement(_index.DmsFlexContainer.Center, null, fingerPrinterEnabled && /*#__PURE__*/_react.default.createElement(_material.IconButton, {
    onClick: handleSubmitFingerPrinter,
    color: "primary",
    sx: {
      ':hover': {
        backgroundColor: 'primary.light'
      }
    }
  }, /*#__PURE__*/_react.default.createElement(_Fingerprint.default, null))), /*#__PURE__*/_react.default.createElement(_index.DmsFlexContainer.Right, null, virtualKeyboard && /*#__PURE__*/_react.default.createElement(_DmsKeyboardButton.DmsKeyboardButton, {
    iconButtonSx: {
      color: 'primary.main',
      ':hover': {
        backgroundColor: 'primary.light'
      }
    }
  }))))))), showModalFingerPrinter && /*#__PURE__*/_react.default.createElement(_DmsAlertPutFinger.default, {
    showModal: showModalFingerPrinter,
    setShowModal: setShowModalFingerPrinter
  }));
};
exports.DmsLogin = DmsLogin;
DmsLogin.propTypes = {
  authentication_url: _propTypes.default.string.isRequired,
  setToken: _propTypes.default.func.isRequired,
  showAutomaticButton: _propTypes.default.bool,
  automaticIcon: _propTypes.default.elementType
};